export const modalReservationDirect = {
  header: {
    title: "Rezerwacje bezpośrednie w sieci",
    subtitle: "Ustaw, co widzi gość i jak stosowane są reguły.",
  },
  tabs: {
    reservations: "Status rezerwacji",
    ratePlans: "Stawki",
    promotions: "Promocje",
    addons: "Opłaty dodatkowe",
    payments: "Ceny i płatności",
    share: "Udostępnianie",
  },
  common: {
    close: "Zamknij",
    updating: "Aktualizowanie…",
    hotel: "Hotel",
    apartment: "Apartament",
    visible: "Widoczna",
    default: "Domyślna",
    dragToReorder: "Przeciągnij, aby zmienić kolejność",
    saving: "Zapisywanie…",
    preview: "Podgląd",
  },
  toast: {
    successTitle: "Gotowe",
  },
  save: {
    ratePlans: "Zapisz stawki",
    promotions: "Zapisz promocje",
    addons: "Zapisz opłaty",
    default: "Zapisz",
  },
  reservations: {
    cardTitle: "Status rezerwacji bezpośrednich",
    cardDesc: "Włącz lub wyłącz dostępność rezerwacji bezpośrednich (globalnie i dla każdej jednostki).",
    activateTitle: "Włącz rezerwacje bezpośrednie",
    activateHelp: "Gdy to jest wyłączone, nie można włączyć pojedynczych jednostek.",
    colName: "Obiekt / jednostka",
    colCapacity: "Pojemność",
    colAvailable: "Dostępna",
    emptyUnits: "Brak skonfigurowanych jednostek dla tego obiektu.",
  },
  ratePlans: {
    title: "Stawki widoczne w rezerwacji bezpośredniej",
    hotelDesc: "Ustaw, które stawki są widoczne dla każdego typu pokoju",
    apartmentDesc: "Wybierz, które plany stawek widzi gość, która jest domyślna oraz ich kolejność",
    loading: "Wczytywanie stawek…",
    emptyApartment: "Brak skonfigurowanych stawek dla tego obiektu.",
    emptyHotel: "Brak skonfigurowanych typów pokoi dla tego hotelu.",
    emptyRoom: "Brak skonfigurowanych stawek dla tego pokoju.",
    colTarifa: "Stawka",
    colVisibleName: "Nazwa wyświetlana",
    visibleNameTooltip: "Opcjonalna nazwa pokazywana gościowi",
    namePlaceholderApartment: "np. Bezzwrotna / Elastyczna",
    namePlaceholderHotel: "np. Ze śniadaniem",
    derivedBadge: "Pochodna",
    rulesApartment: "Zasady: co najmniej 1 widoczna i 1 domyślna (która musi być widoczna).",
    rulesHotel: "Każdy pokój musi mieć co najmniej 1 widoczną stawkę i 1 domyślną.",
  },
  rooms: {
    ratesCount: "{count} stawka | {count} stawki | {count} stawek",
    meta: "Pojemność: {capacity} • Dorośli: {adults} • Dzieci: {children}",
  },
  promotions: {
    title: "Promocje w rezerwacji bezpośredniej",
    desc: "Kontroluj, które są widoczne, czy stosują się automatycznie i w jakiej kolejności.",
    loading: "Wczytywanie promocji…",
    empty: "Brak skonfigurowanych promocji dla tego obiektu.",
    colPromo: "Promocja",
    colBadge: "Etykieta",
    badgeTooltip: "Krótki tekst (np. -10%, Okazja, Early Bird).",
    colAuto: "Stosuj automatycznie",
    colStackable: "Łączona",
    badgePlaceholder: "np. -10% / Okazja",
    tip: "Wskazówka: jeśli promocja nie ma wpływać na cenę końcową, wyłącz „Stosuj automatycznie” i pozostaw ją widoczną.",
    fromDate: "Od {date}",
    untilDate: "Do {date}",
  },
  addons: {
    loading: "Wczytywanie ustawień…",
    subtabOccupancy: "Rabat za obłożenie",
    subtabExtraGuest: "Opłata za dodatkowego gościa",
    baseOccupancyTitle: "Obłożenie bazowe",
    baseOccupancyDesc: "Zwykła cena odpowiada temu obłożeniu. Przy mniejszej liczbie gości stosowana jest obniżka.",
    guestsLabel: "goście",
    headOccupancy: "Obłożenie",
    headRule: "Reguła",
    headValue: "Wartość",
    headActive: "Aktywna",
    guestWord: "gość | goście | gości",
    usualPrice: "Zwykła cena",
    modePercent: "Obniżka %",
    modeFixed: "Obniżka kwotowa (za noc)",
    occupancyExample: "Przykład: baza 4 gości oraz rabaty dla 3, 2 i 1.",
    configTitle: "Ustawienia",
    configDesc: "Naliczaj dopłatę za każdego gościa ponad wliczone obłożenie.",
    activate: "Włącz",
    includedTitle: "Wliczone obłożenie",
    includedDesc: "Pobierane automatycznie z pojemności obiektu.",
    maxExtraLabel: "Maksymalna liczba dodatkowych gości",
    maxHelpHtml: "Ilu gości można dodać <b>ponad wliczone obłożenie</b>.<br />Ustawienie <b>0</b> oznacza brak zgody na dodatkowych gości.<br />Pozostawienie pustego pola oznacza brak limitu.",
    chargeTypeLabel: "Rodzaj opłaty",
    chargeTypeFixed: "Kwota stała",
    chargeTypePercentage: "Procent",
    chargeTypeHelp: "Stała: {currency} za dodatkowego gościa. Procent: % ceny bazowej.",
    priceLabel: "Cena za dodatkowego gościa",
    appliesHelp: "Naliczana za każdego dodatkowego gościa.",
    appliesBlockedNote: "(Przy maksimum równym 0 dodatkowi goście nie są dozwoleni)",
    applicationLabel: "Naliczanie",
    applicationNote: "Na razie ta opłata naliczana jest za noc.",
    previewFixed: "Każdy dodatkowy gość to <b>{amount}</b> za noc.",
    previewPercent: "Każdy dodatkowy gość to <b>{percent}%</b> ceny bazowej za noc.",
    singleValueNote: "To <b>jedna wartość</b> (np. +10 {currency} lub +15% za dodatkowego gościa).",
  },
  payments: {
    title: "Ceny i płatności",
    desc: "Rodzaj płatności i rabaty dla rezerwacji bezpośrednich.",
    paymentTypeTitle: "Rodzaj płatności",
    onArrivalLabel: "Płatność na miejscu",
    onArrivalDesc: "Gość rezerwuje i płaci bezpośrednio po przyjeździe.",
    onlineLabel: "Płatność online",
    onlineDesc: "Gość płaci online podczas finalizowania rezerwacji.",
    discountsTitle: "Rabaty",
    enableDiscount: "Włącz rabat na rezerwacje bezpośrednie",
    discountTypeTitle: "Rodzaj rabatu",
    typePercentage: "Procentowy",
    typePercentageDesc: "Rabat proporcjonalny do sumy.",
    typeFixed: "Kwotowy",
    typeFixedDesc: "Stała kwota do odliczenia.",
    valueTitle: "Wartość",
    placeholderPercentage: "np. 10",
    placeholderFixed: "np. 15,00",
    helpPercentage: "Maksymalnie 100%. Naliczany od sumy.",
    helpFixed: "Odliczana jest stała kwota w {currency}.",
    previewPercentage: "Zostanie zastosowany rabat {percent}%.",
    previewFixed: "Zostanie zastosowany rabat {amount}.",
  },
  share: {
    title: "Udostępnianie",
    desc: "Skopiuj link do rezerwacji bezpośredniej i udostępnij go na WhatsApp lub otwórz widok gościa.",
    linkLabel: "Link do rezerwacji",
    linkHelp: "To link, który udostępnia się gościom.",
    viewAsGuest: "Zobacz jako gość",
    tip: "Wskazówka: udostępniaj ten link w bio, wiadomościach automatycznych i kampaniach.",
    whatsappMessage: "Cześć 👋 Oto link do rezerwacji: {link}",
  },
  errors: {
    loadRatePlans: "Nie udało się wczytać stawek.",
    saveRatePlans: "Nie udało się zapisać stawek.",
    roomMinVisible: 'Pokój "{name}" musi mieć co najmniej 1 widoczną stawkę.',
    roomExactlyOneDefault: 'Pokój "{name}" musi mieć dokładnie 1 stawkę domyślną.',
    roomDefaultMustBeVisible: 'W pokoju "{name}" stawka domyślna musi być widoczna.',
    aptMinVisible: "Należy zachować co najmniej 1 widoczną stawkę.",
    aptExactlyOneDefault: "Musi być dokładnie 1 stawka domyślna.",
    aptDefaultMustBeVisible: "Stawka domyślna musi być widoczna.",
    loadPromotions: "Nie udało się wczytać promocji.",
    savePromotions: "Nie udało się zapisać promocji.",
    saveAddons: "Nie udało się zapisać opłat dodatkowych.",
    maxExtraRange: "Maksymalna liczba dodatkowych gości musi mieścić się między 0 a 50 (lub puste = brak limitu).",
    extraPriceInvalid: "Cena za dodatkowego gościa musi być prawidłowa (>= 0).",
    percentRange: "Procent musi mieścić się między 0 a 100.",
    baseOccupancyRange: "Obłożenie bazowe musi mieścić się między 1 a {max}.",
    discountValuesInvalid: "Wartości rabatu muszą być prawidłowymi liczbami (>= 0).",
    discountPercentMax: "Rabat procentowy nie może przekraczać 100.",
    updateFailed: "Nie udało się zaktualizować.",
    updateUnitFailed: "Nie udało się zaktualizować statusu jednostki.",
    updateGlobalFailed: "Nie udało się zaktualizować statusu globalnego.",
    noLinkCopy: "Brak linku do skopiowania.",
    copyFailed: "Nie udało się skopiować linku.",
    noLinkShare: "Brak linku do udostępnienia.",
    noLinkOpen: "Brak linku do otwarcia.",
    updatePaymentType: "Nie udało się zaktualizować rodzaju płatności.",
    savePayments: "Nie udało się zapisać zmian.",
  },
  success: {
    ratePlansSaved: "Stawki zapisane pomyślnie.",
    promotionsSaved: "Promocje zapisane pomyślnie.",
    addonsSaved: "Opłaty dodatkowe zapisane pomyślnie.",
    updated: "Zaktualizowano pomyślnie.",
    globalUpdated: "Status globalny zaktualizowany.",
    linkCopied: "Link skopiowany.",
    changesSaved: "Zmiany zapisane.",
  },
};
